import React from 'react';
import { Grid } from '@mui/material';

interface ITrainingHeaderProps {
  children?: React.ReactNode;
  title: string;
}

const TrainingHeader: React.FC<ITrainingHeaderProps> = (
  props: ITrainingHeaderProps,
) => {
  const { children, title } = props;
  return (
    <section
      className='home-content-body Training-HeaderDown'
      style={{ minHeight: 0 }}
    >
      <Grid container>
        <Grid item xs={12}>
          <div className='TrainingHeaderTitle'>
            <div style={{ marginLeft: '20px' }}>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='24'
                height='25'
                viewBox='0 0 24 25'
                fill='none'
              >
                <path
                  d='M16 10.77L11 7.88C10.6961 7.70455 10.3514 7.61214 10.0005 7.61205C9.64962 7.61196 9.30487 7.70419 9.00089 7.87949C8.69691 8.05478 8.44441 8.30697 8.26872 8.61072C8.09304 8.91447 8.00036 9.2591 8 9.61V15.39C8.00036 15.7407 8.09295 16.0852 8.26847 16.3888C8.44398 16.6925 8.69627 16.9446 9 17.12C9.30404 17.2955 9.64893 17.3879 10 17.3879C10.3511 17.3879 10.696 17.2955 11 17.12L16 14.23C16.3031 14.0542 16.5547 13.8018 16.7295 13.4982C16.9044 13.1946 16.9965 12.8504 16.9965 12.5C16.9965 12.1496 16.9044 11.8054 16.7295 11.5018C16.5547 11.1982 16.3031 10.9458 16 10.77ZM15 12.5L10 15.39V9.61L15 12.5ZM12 2.5C10.0222 2.5 8.08879 3.08649 6.4443 4.1853C4.79981 5.28412 3.51809 6.8459 2.76121 8.67317C2.00433 10.5004 1.8063 12.5111 2.19215 14.4509C2.578 16.3907 3.53041 18.1725 4.92894 19.5711C6.32746 20.9696 8.10929 21.922 10.0491 22.3079C11.9889 22.6937 13.9996 22.4957 15.8268 21.7388C17.6541 20.9819 19.2159 19.7002 20.3147 18.0557C21.4135 16.4112 22 14.4778 22 12.5C22 11.1868 21.7413 9.88642 21.2388 8.67317C20.7363 7.45991 19.9997 6.35752 19.0711 5.42893C18.1425 4.50035 17.0401 3.76375 15.8268 3.2612C14.6136 2.75866 13.3132 2.5 12 2.5ZM12 20.5C10.4178 20.5 8.87104 20.0308 7.55544 19.1518C6.23985 18.2727 5.21447 17.0233 4.60897 15.5615C4.00347 14.0997 3.84504 12.4911 4.15372 10.9393C4.4624 9.38743 5.22433 7.96197 6.34315 6.84315C7.46197 5.72433 8.88743 4.9624 10.4393 4.65372C11.9911 4.34504 13.5997 4.50346 15.0615 5.10896C16.5233 5.71447 17.7727 6.73984 18.6518 8.05544C19.5308 9.37103 20 10.9177 20 12.5C20 14.6217 19.1572 16.6566 17.6569 18.1569C16.1566 19.6571 14.1217 20.5 12 20.5Z'
                  fill='var(--text-primary)'
                />
              </svg>
            </div>
            <div>
              <h2>{title}</h2>
            </div>
          </div>
        </Grid>
        <div className='HomeDashboard-container'>{children}</div>
      </Grid>
    </section>
  );
};

export default TrainingHeader;
